import * as React from 'react';
import {
    ThemeProvider as MuiThemeProvider
} from '@material-ui/core/styles';
import RCApp from '../components/RC/Main/RCApp';
// import SimpleExample from "../components/SimpleExample";
import muiTheme from './Theme';

const Root = () => (
    <MuiThemeProvider theme={muiTheme}>
        <RCApp />
        {/*<SimpleExample/>*/}
    </MuiThemeProvider>
);

export default Root;